import { CustomerWithDefaultAddress } from './customer.interface';

export interface Inquiry {
  id?: number;
  customer_id?: number;
  reservation_id?: number;
  invoice_id?: number;
  type: InquiryTypeTypes;
  description: string;
  status: InquiryStatusTypes;
  archived: number | boolean;
  customer?: CustomerWithDefaultAddress;
  messages?: InquiryMessage[];
  created_at?: string;
  updated_at?: string;
}

export interface InquiryMessage {
  id?: number;
  inquiry_id: number;
  customer_id: number;
  author_type: 'customer' | 'admin';
  message: string;
  created_at?: string;
  updated_at?: string;
}

export type InquiryTypeTypes = 'general' | 'reservation' | 'storno' | 'invoice';
export const InquiryTypeTypesMapper: Record<InquiryTypeTypes, string> = {
  general: 'Allgemein',
  reservation: 'Rückfrage Reservierung',
  storno: 'Storno',
  invoice: 'Rückfrage Rechnung',
};

export type InquiryStatusTypes = 'open' | 'resolved';
export const InquiryStatusTypesMapper: Record<InquiryStatusTypes, string> = {
  open: 'Offen',
  resolved: 'Erledigt',
};

export interface InquiryStatusParams {
  inquiry_id: number;
  status: InquiryStatusTypes;
}
